// 고객 문의 메일 본문 조립
//
// 왜 정보를 붙이나 — 지금까지 문의는 빈 메일로 도착해서 "누가 · 어느 빌드 · 어느 OS에서"
// 겪은 문제인지 알 수 없었다. 답장 한 번에 되물어야 할 것들을 처음부터 담는다.
// 유저가 메일 앱에서 보내기 전에 전문을 볼 수 있으므로 몰래 수집이 아니다.
// 개인정보 최소화: 계정 이메일은 넣지 않고 user_id 앞 8자만 — 서버 조회에는 이걸로 충분하다.

import { Capacitor } from "@capacitor/core";

export interface InquiryContext {
  nickname: string | null;
  userId: string | null;
  provider: string | null;   // kakao · google · naver · email
  appVersion: string;
  buildTime: string;
  platform: string;          // ios · android · web
  screen: string;            // 375×667 @3x
  at: string;                // 문의 시각 (KST)
}

const DIVIDER = "────────────────────";

/** 메일 본문 — 맨 위를 비워 유저가 바로 쓰게 하고, 진단 정보는 아래에 모아둔다. */
export function buildInquiryBody(ctx: InquiryContext): string {
  const account = ctx.userId
    ? `${ctx.nickname || "(닉네임 없음)"} (${ctx.userId.slice(0, 8)})${ctx.provider ? ` · ${ctx.provider}` : ""}`
    : "비로그인";

  return [
    "문의 내용을 이 위에 적어주세요.",
    "",
    "",
    DIVIDER,
    "▼ 문제 파악용 정보 (지우지 말아주세요)",
    `· 계정: ${account}`,
    `· 앱: ${ctx.appVersion} (빌드 ${ctx.buildTime})`,
    `· 환경: ${ctx.platform} · ${ctx.screen}`,
    `· 시각: ${ctx.at}`,
  ].join("\n");
}

/** 현재 실행 환경에서 진단 정보를 모은다. user는 supabase session.user. */
export function collectInquiryContext(
  user: { id?: string; email?: string; user_metadata?: Record<string, unknown>; app_metadata?: Record<string, unknown> } | null,
  appVersion: string,
  buildTime: string,
): InquiryContext {
  const meta = user?.user_metadata ?? {};
  const nickname = (meta.nickname as string) || (meta.name as string) || null;
  const dpr = typeof window !== "undefined" && window.devicePixelRatio ? `@${window.devicePixelRatio}x` : "";
  const screen = typeof window !== "undefined"
    ? `${window.innerWidth}×${window.innerHeight}${dpr ? ` ${dpr}` : ""}`
    : "unknown";

  return {
    nickname,
    userId: user?.id ?? null,
    provider: (user?.app_metadata?.provider as string) ?? null,
    appVersion,
    buildTime,
    platform: Capacitor.getPlatform(),
    screen,
    at: new Date().toLocaleString("ko-KR", { timeZone: "Asia/Seoul" }),
  };
}
